module.exports = __webpack_public_path__ + "static/img/spring_banner.3a4ed8a6.jpg";